var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-iframe-ani"},[_c('iframeAni',{key:_vm.refreshKey,on:{"refresh-component":_vm.refreshComponent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }